import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const LocaleProviderContext = createContext([]);
LocaleProviderContext.displayName = "localProvider";
;
export const useLocaleProvider = () => useContext(LocaleProviderContext);
export const useTranslate = (languageStrings) => (string) => languageStrings[string];
export const LocaleProvider = ({ children, languageStrings }) => {
    return (_jsx(LocaleProviderContext.Provider, { value: languageStrings, children: children }));
};
